export const QualificationType = { UNDERGRAD: 'Undergraduate', POSTGRAD: 'Postgraduate' };
